import animation from '@helpers/animation';
import brand from '@helpers/brand';
import { ButtonReset } from '@helpers/global';
import { Device, from } from '@helpers/media';
import { slickCss, slickThemeCss } from '@helpers/slick';
import { LazyImageStyles } from '@stories/Elements/Media/LazyImage/LazyImage.styles';
import { LoaderStyles } from '@stories/Elements/Misc/Loader/Loader.styles';
import { Column, Grid } from '@stories/Settings/Grids/Grid.styles';
import styled, { css } from 'styled-components';

const Container = styled(Column.DefaultGridBreakout)``;

const Slide = styled.div`
  position: relative;
  aspect-ratio: 1 / 1;

  ${LazyImageStyles.Image}, video {
    width: 100%;
    height: 100%;
  }

  video {
    object-fit: cover;
    object-position: center;
  }
`;

const Carousel = styled.div`
  position: relative;
  ${slickCss};
  ${slickThemeCss};
`;

const Indicators = styled.div`
  ${Grid.defaultPadding};
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 2px;

  span {
  }
`;

const IFrameWrapper = styled.div`
  position: relative;
  aspect-ratio: 1 / 1;

  ${LoaderStyles.Wrapper} {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 0;
  }

  iframe {
    position: absolute;
    top: 50%;
    left: 0;
    width: 100%;
    z-index: 1;
    aspect-ratio: 16/9;
    transform: translateY(-50%);
  }
`;

const Indicator = styled.span<{ isActive: boolean }>`
  display: block;
  height: 4px;
  border-radius: 5px;
  width: 100%;

  ${({ isActive }) =>
    isActive
      ? css`
          background-color: ${brand.red.base};
        `
      : css`
          background-color: transparent;
        `}
`;

const AbsoluteOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: block;

  ${Grid.Default} {
    align-items: center;
    justify-items: center;
    height: 100%;
  }
`;

const Arrow = styled.span<{ isNext?: boolean; disabled?: boolean }>`
  color: ${brand.white};
  z-index: 10;
  user-select: none;
  display: block;
  filter: drop-shadow(0px 2px 3px ${brand.black}80);

  ${({ disabled }) =>
    disabled
      ? css`
          opacity: 0.5;
        `
      : css`
          cursor: pointer;

          &:hover svg {
            transform: scale(1.25);
          }
        `}

  ${({ isNext }) =>
    isNext
      ? css`
          grid-column: 12;
        `
      : css`
          grid-column: 1;
          transform: rotate(180deg);
        `}

  svg {
    height: 26px;
    transition: transform 275ms ${animation.easeInOutCubic};

    @media ${from(Device.TabletLarge)} {
      height: 40px;
    }
  }
`;

const ZoomButton = styled.button.attrs({ type: 'button' })`
  ${ButtonReset};

  position: absolute;
  bottom: 12px;
  right: 12px;

  width: 46px;
  height: 46px;
  background-color: ${brand.white};
  display: grid;
  place-items: center;
  padding: 10px;
  border-radius: 50%;
  box-shadow: 1px 1px 10px ${brand.black}33;

  svg {
    color: ${brand.red.base};
    width: 100%;
  }
`;

export const ProductMediaMobileStyles = {
  Container,
  Slide,
  Carousel,
  Indicators,
  Indicator,
  IFrameWrapper,
  AbsoluteOverlay,
  Arrow,
  ZoomButton,
};
